import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import arrowLeftIcon from "../../assets/icon-left.svg";
import { useBrandThemeColors } from "../../branding";
import { useModuleDisplayName } from "../../hooks/useModuleDisplayName";

type AiHubDetailBreadcrumbProps = Readonly<{
  /** Defaults to `/global/config` `module_display_name` (fallback AI Hub). */
  parentLabel?: string;
  currentLabel: string;
  onBack: () => void;
}>;

export default function AiHubDetailBreadcrumb({
  parentLabel,
  currentLabel,
  onBack,
}: AiHubDetailBreadcrumbProps) {
  const { primaryColor } = useBrandThemeColors();
  const moduleDisplayName = useModuleDisplayName();
  const resolvedParentLabel = parentLabel?.trim() || moduleDisplayName;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      <IconButton
        aria-label="Go back"
        onClick={onBack}
        sx={{ width: 32, height: 32, p: 1, flexShrink: 0 }}
      >
        <Box
          component="img"
          src={arrowLeftIcon}
          alt=""
          sx={{
            width: 16.25,
            height: 16,
            display: "block",
            objectFit: "contain",
          }}
        />
      </IconButton>
      <Breadcrumbs
        separator="›"
        sx={{ "& .MuiBreadcrumbs-separator": { color: "#9ca3af", mx: 1 } }}
      >
        <Link
          component="button"
          variant="body1"
          onClick={onBack}
          sx={{
            color: primaryColor,
            textDecoration: "none",
            cursor: "pointer",
            fontSize: "0.875rem",
            "&:hover": { textDecoration: "underline" },
          }}
        >
          {resolvedParentLabel}
        </Link>
        <Typography
          sx={{ color: "#374151", fontSize: "0.875rem", fontWeight: 500 }}
        >
          {currentLabel}
        </Typography>
      </Breadcrumbs>
    </Box>
  );
}
